<!-- top-menu start -->
<!-- <nav class="navbar {{activePath}} {{scrolled ? 'nav-fixed' : ''}} {{activePath === 'order-online' ? 'oo-header' : 'fixed-top'}}"> -->
<nav class="navbar {{activePath}} {{showHeaderClass ? 'showHeader' : ''}} 
{{hideHeaderClass ? 'hideHeader' : ''}} {{scrolled ? 'bg-header nav-fixed' : ''}}">
  <div class="container-fluid p-3 p-md-0">
    <button class="navbar-toggler" type="button" (click)="menuModal.show()">
      <span class="icon"><i class="flaticon-left-alignment" ></i></span>
    </button>
    <a class="navbar-brand d-none d-md-block" title="{{(data | async)?.restaurant_data?.restaurant_name}}" [routerLink]="['/']">
      <img class="img-fluid" [defaultImage]="'./assets/images/placeholder.jpg'" [lazyLoad]="(data | async)?.restaurant_data?.logo" 
      alt="{{(data | async)?.restaurant_data?.logo_alt_text ? (data | async)?.restaurant_data?.logo_alt_text : (data | async)?.restaurant_data?.restaurant_name}}" />
    </a>
    <div class="navbar-btns">
      <a class="btn btn-outline-primary {{scrolled ? 'hide-btn' : ''}}" [title]="'Reserve a table at ' + (data | async)?.restaurant_data?.restaurant_name" *ngIf="(data | async)?.restaurant_content?.booking_page?.is_active" 
      [routerLink]="['/reservation']" routerLinkActive="active">Reserve</a>
      <a class="btn btn-outline-primary {{scrolled ? 'hide-btn' : ''}}" [title]="'Order food online from ' + (data | async)?.restaurant_data?.restaurant_name" *ngIf="(data | async)?.restaurant_content?.order_online_page?.is_active" 
      [routerLink]="['/order-online']" routerLinkActive="active">Order Now</a>  
    </div>
  </div>
</nav>

<div class="modal fade menu-modal" bsModal #menuModal="bs-modal"  tabindex="-1" role="dialog">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="btn" (click)="menuModal.hide()">
          <span class="icon"><i class="flaticon-unchecked" ></i></span>
        </button>
      </div>
      <div class="modal-body">
        <ul class="navbar-nav">
          <li class="nav-item" (click)="menuModal.hide()">
            <a class="nav-link" title="Home" [routerLink]="['/']" routerLinkActive="active">Home</a>
          </li>
          <li class="nav-item" (click)="menuModal.hide()" *ngIf="(data | async)?.restaurant_content?.about_page?.is_active">
            <a class="nav-link" title="About" [routerLink]="['/about-us']" routerLinkActive="active">About</a>
          </li>
          <li class="nav-item" (click)="menuModal.hide()" *ngIf="(data | async)?.restaurant_content?.team_page?.is_active">
            <a class="nav-link" title="Team" [routerLink]="['/our-team']" routerLinkActive="active">Team</a>
          </li>
          <li class="nav-item" (click)="menuModal.hide()" *ngIf="(data | async)?.restaurant_content?.deals_page?.is_active">
            <a class="nav-link" title="Deals" [routerLink]="['/deals']" routerLinkActive="active">Deals</a>
          </li>
          <li class="nav-item" (click)="menuModal.hide()" *ngIf="(data | async)?.restaurant_content?.menu_page?.is_active">
            <a class="nav-link" title="Menu" [routerLink]="['/menu']" routerLinkActive="active">Menu</a>
          </li>
          <li class="nav-item" (click)="menuModal.hide()" *ngIf="(data | async)?.restaurant_content?.booking_page?.is_active">
            <a class="nav-link" title="Reservation" [routerLink]="['/reservation']" routerLinkActive="active">Reserve</a>
          </li>
          <li class="nav-item" (click)="menuModal.hide()" *ngIf="(data | async)?.restaurant_content?.order_online_page?.is_active">
            <a class="nav-link" title="Order Now" [routerLink]="['/order-online']" routerLinkActive="active">Order Now</a>
          </li>
          <li class="nav-item" (click)="menuModal.hide()" *ngIf="(data | async)?.restaurant_content?.review_page?.is_active">
            <a class="nav-link" title="Reviews" [routerLink]="['/reviews']" routerLinkActive="active">Reviews</a>
          </li>
          <li class="nav-item" (click)="menuModal.hide()" *ngIf="(data | async)?.restaurant_content?.gallery_page?.is_active">
            <a class="nav-link" title="Gallery" [routerLink]="['/gallery']" routerLinkActive="active">Gallery</a>
          </li>
          <li class="nav-item" (click)="menuModal.hide()" *ngIf="(data | async)?.restaurant_content?.awards_page?.is_active">
            <a class="nav-link" title="Awards" [routerLink]="['/awards']" routerLinkActive="active">Awards</a>
          </li>
          <li class="nav-item" (click)="menuModal.hide()" *ngIf="(data | async)?.restaurant_content?.xmas_page?.is_active">
            <a class="nav-link" title="Christmas" [routerLink]="['/christmas']" routerLinkActive="active">Christmas</a>
          </li>
          <li class="nav-item" (click)="menuModal.hide()" *ngIf="(data | async)?.restaurant_content?.event_page?.is_active">
            <a class="nav-link" title="Events" [routerLink]="['/events']" routerLinkActive="active">Events</a>
          </li>
          <li class="nav-item" (click)="menuModal.hide()" *ngIf="(data | async)?.restaurant_content?.blog_page?.is_active">
            <a class="nav-link" title="Blog" [routerLink]="['/blogs']" routerLinkActive="active">Blog</a>
          </li>
          <li class="nav-item" (click)="menuModal.hide()" *ngIf="(data | async)?.restaurant_content?.news_media_page?.is_active">
            <a class="nav-link" title="News & Media - {{(data | async)?.restaurant_data?.restaurant_name}}" [routerLink]="['/news-media']" routerLinkActive="active">News & Media</a>
          </li>
          <li class="nav-item" (click)="menuModal.hide()" *ngIf="(data | async)?.restaurant_content?.contact_page?.is_active">
            <a class="nav-link" title="Contact" [routerLink]="['/contact-us']" routerLinkActive="active">Contact</a>
          </li>
          <li class="nav-item" (click)="menuModal.hide()" *ngIf="(user | async)?.isLogged === false">
            <a class="nav-link" title="Sign In" [routerLink]="['/sign-in']" routerLinkActive="active">Sign In</a>
          </li>
          <li class="nav-item" (click)="menuModal.hide()" *ngIf="(user | async)?.isLogged === true">
            <a class="nav-link" title="My Account" [routerLink]="['/my-account']" routerLinkActive="active">My Account</a>
          </li>
        </ul>
        <ul class="navbar-nav info-menu">
          <li class="address">
            <span class="svg-icon"><i class="flaticon-placeholder-1" ></i></span>
            <p class="location">
              <!-- <span class="tag">Address</span><br> -->
              <a title="{{restaurant_address}}" href="{{(data | async)?.restaurant_data?.map_url ? (data | async)?.restaurant_data?.map_url : 'https://www.google.com/maps/search/'+restaurant_address}}" target="_blank">{{restaurant_address}}</a>
            </p>
          </li>
          <li class="contacts" *ngIf="(data | async)?.restaurant_data?.business_tel && (data | async)?.restaurant_data?.business_tel !==''">
            <span class="svg-icon"><i class="flaticon-phone" ></i></span>
            <p>
              <!-- <span class="tag">Call us now</span><br> -->
              <span *ngFor="let item of (data | async)?.restaurant_data?.business_tel | split">
                <a title="{{item.trim()}}" href="tel:{{item.trim()}}" >{{item.trim()}}</a><br>
              </span>
            </p>
          </li>
          <li class="email" *ngIf="(data | async)?.restaurant_data?.email && (data | async)?.restaurant_data?.email !==''">
            <span class="svg-icon"><i class="flaticon-envelope" ></i></span>
            <p>
              <!-- <span class="tag">Send an email</span><br> -->
              <a title="{{(data | async)?.restaurant_data?.email}}" href="mailto:{{(data | async)?.restaurant_data?.email}}">{{(data | async)?.restaurant_data?.email}}</a>
            </p>
          </li>
          <p class="social-btn-wrapper mb-3" *ngIf="(data | async)?.restaurant_data?.social_media && (data | async)?.restaurant_data?.social_media?.length > 0">
            <a *ngFor="let item of (data | async)?.restaurant_data?.social_media" title="{{item.media_name}}" href="{{item?.link}}" target="_blank" class="btn {{item.media_name}}">
              <span class="social-icon"><img src="../../.././../assets/social-icon/{{item.media_name}}.svg" alt="{{item.media_name}}"></span>
            </a>
          </p>

          <!-- <p class="social-btn-wrapper mb-3" *ngIf="(data | async)?.restaurant_data?.social_media && (data | async)?.restaurant_data?.social_media?.length > 0">
            <a *ngFor="let item of (data | async)?.restaurant_data?.social_media" href="{{item?.link}}" target="_blank" class="btn {{item.media_name}}">
              <span class="social-icon"><i class="fa-brands fa-{{item.media_name}}"></i></span>
            </a>
          </p> -->
        </ul>
      </div>
    </div>
  </div>
</div>
<!-- top-menu end -->